import PropTypes from "prop-types";
import Client from "./Customer";
import Parent from "./Parent";
import { createField, getEntityTypes, getEntityDefaults } from "./utils";

const TaxesPersonalInfo = {
    fileNo: createField(PropTypes.string, ""),
    prefix: createField(PropTypes.string, ""),
    consecutive: createField(PropTypes.number, 0),
    client: createField(PropTypes.shape(getEntityTypes(Client)), getEntityDefaults(Client)),
    startDate: createField(PropTypes.instanceOf(Date), null),
    type: createField(PropTypes.shape({}), null),
    status: createField(PropTypes.shape({}), null),
    notes: createField(PropTypes.string, ""),
    fileLocation: createField(PropTypes.shape({}), null),
    parent: createField(PropTypes.shape(getEntityTypes(Parent)), getEntityDefaults(Parent)),
    parentId: createField(PropTypes.number, null),
    trnFlowId: createField(PropTypes.number, null),
    assigneeUser: createField(PropTypes.shape({}), null),
    workStatus: createField(PropTypes.string, "casePreparation"),
};

export default TaxesPersonalInfo;

// Set of date-type fields that might be used for calendar event purposes
export const getEventFields = () => [];
